<template>
    <multiselect :options="opciones" :disabled="disabled" :class="!valid ? '' : 'is-invalid'" :searchable="true" :value="value" track-by="dt1" label="dt1" v-model="elejido" :loading="cargando" :allowEmpty="false" :placeholder="placeholder" :name="name" :close-on-select="true"  :show-labels="false">
        <span slot="noOptions">No hay datos</span>
        <span slot="noResult">No existen coincidencias</span>
        <template slot="singleLabel" slot-scope="props">
            <span class="option__desc"><span class="option__title">{{ props.option.dt1 }}</span></span>
        </template>
        <template slot="option" slot-scope="props">
            <div class="option__desc"><span class="option__title">{{ props.option.dt1 }}</span></div>
        </template>
    </multiselect>
</template>

<script>
    const vacio =[{id:0}];
    import Multiselect from 'vue-multiselect'
    export default {
        name: "comboBox",
        components:{
            Multiselect
        },
        props:{
            opciones:{
                type: Array,
                required: true,
                default:()=>(vacio)
            },
            value:{
                type: Object,
                default: function () {
                    return null
                }
            },
            name:{
                type: String
            },
            disabled:{
                type: Boolean,
                default: false,
            },
            valid:{
                type: Boolean,
                default:false,
                required: false
            },
            placeholder:{
                type: String,
                default: function () {
                    return this.name
                }
            }
        },
        data () {
            return {
                elejido:this.value,
                cargando:false,
            }
        },
        watch:{
            value:function(val){
                this.elejido=val;
            },
            opciones:function(){
                //this.cargando=false;
                //this.cargando = false;
            },
            elejido:function(val){
                this.$emit('input', val);
            }
        },
        created() {

        }
    }
</script>

<style scoped>

</style>
